import CompanyQuoteIncorporationInfo from './CompanyQuoteIncorporationInfo'
export { CompanyQuoteIncorporationInfo }
export default CompanyQuoteIncorporationInfo
